/** IDs canônicos de db_dfe.disponibilidade_documento_sefaz. */
export enum DisponibilidadeDocumentoSefazEnum {
  Identificado = 1,
  ResumoRecebido = 2,
  DocumentoCompleto = 3,
}
